import { injectable } from "inversify";
import { EventDispatcher } from "@dp-instant/core";
import { IUser, IScore } from "@dp-instant/social";

@injectable()
class TelegramScore extends EventDispatcher implements IScore {
    private _session = 0;
    setScoreSession(value: number): void { this._session = value; }
    update(_context?: any, _global?: any): void {}
    getScore(_mask?: number): number { return this._session; }
    getEntry(_type: any): any { return undefined; }
    flush(): void {}
}

@injectable()
export class TelegramUser extends EventDispatcher implements IUser {
    rawData: any = null;
    private _scores = new TelegramScore();
    private _id = "0";
    private _name = "Player";
    private _photo = "";
    private _scoreSession = 0;
    private _isNew = false;

    constructor(id?: string, name?: string, photo?: string) {
        super();
        if (id) this._id = id;
        if (name) this._name = name;
        if (photo) this._photo = photo;
    }

    init(source: any, isNew = false): this {
        this.rawData = source;
        this._isNew = isNew;
        if (source) {
            if (source.getUniqueID) this._id = String(source.getUniqueID());
            if (source.getPhoto) this._photo = source.getPhoto();
        }
        return this;
    }

    get id(): string { return this._id; }
    get name(): string { return this._name; }
    get photo(): string { return this._photo; }
    get scoreGlobal(): number { return 0; }
    get scoreContext(): number { return 0; }
    get scores(): IScore { return this._scores; }
    get isNew(): boolean { return this._isNew; }
    get scoreSession(): number { return this._scoreSession; }
    set scoreSession(value: number) {
        this._scoreSession = value;
        this._scores.setScoreSession(value);
    }
}
